import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { SeasonalityComponent } from './pages/seasonality/seasonality.component';
import { FleetComponent } from './pages/fleet/fleet.component';
import { SiteSettingsComponent } from './pages/sites/site-settings.component';
import { NavCheckService } from './shared/services/navCheckService';
import { StockComponent } from './pages/stock/stock.component';
import { ForecastComponent } from './pages/forecast/forecast.component';
import { TireComponent } from './pages/tire/tire.component';

export const routes: Routes = [
  {
    path: '',
    canActivateChild: [NavCheckService],
    children: [
      {
        path: '',
        component: LayoutComponent,
        children: [
          { path: '', redirectTo: 'forecast', pathMatch: 'full' },
          { path: 'forecast', component: ForecastComponent },
          { path: 'sites', component: SiteSettingsComponent },
          { path: 'sites/seasonality', component: SeasonalityComponent },
          { path: 'fleet', component: FleetComponent },
          { path: 'stock', component: StockComponent },
          { path: 'tire', component: TireComponent }
        ]
      }
    ]
  },
  { path: '**', redirectTo: '', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
